import React from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";

import { Paper, Typography } from "@mui/material";

import { ReactComponent as Logo } from "../../vendor/logo.svg";
import PasswordComponent from "../../components/auth/Password";

const Brand = styled(Logo)`
  fill: ${(props) => props.theme.palette.primary.main};
  width: 64px;
  height: 64px;
  margin-bottom: 32px;
`;

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

function Password() {
  return (
    <React.Fragment>
      <Brand />
      <Wrapper>
        <Helmet title="Khôi phục mật khẩu" />

        <Typography component="h1" variant="h4" align="center" gutterBottom>
          Nhập lại mật khẩu
        </Typography>
        <Typography component="h2" variant="body1" align="center">

          Nhập mật khẩu để thiết lập lại mật khẩu của bạn
        </Typography>

        <PasswordComponent />
      </Wrapper>
    </React.Fragment>
  );
}

export default Password;
